import { ChangeDetectorRef, Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin, merge } from 'rxjs';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { Subscription } from 'rxjs';
import { ConfigureFormFieldsView } from '../models/ConfigureFormFieldsView';


@Component({
  standalone: false,
  selector: 'app-non-enumerated-provider-details',
  templateUrl: './non-enumerated-provider-details.component.html',
  styleUrls: ['./non-enumerated-provider-details.component.css','../shared/css/common.css']
})
export class NonEnumeratedProviderDetailsComponent implements OnInit, OnDestroy {

  nonEnumeratedProviderForm = this.providerFormBuilder.group({});
  nonEnumeratedProviderFormData: any;
  formdata : any | null;
  payorkey: number;
  title: string = "Provider";
  isformloaded: boolean = false;
  isInstruction: boolean = false;
  instructionText!: string | null;

  nonEnumeratedProviderFormData1: any = {};
  nonEnumeratedProviderFormData2: any = {};
  nonEnumeratedProviderFormData3: any = {};
  internalInvolvedPartiesKey:number=0;
  isNameRequired:boolean = false;
  isRequiredIdLabelVisible:boolean = false;
  isFormsValid : boolean = false;
  statelist: StateNames[] = [];
  primaryColor?: string = "";
  private initCount = 0;
  private nameSubscription?: Subscription;
  private stateSubscription?: Subscription;
  private formSubscription?: Subscription;
  configureFormFields: ConfigureFormFieldsView[] = [];
  
  @Input() inputDetails: any;
  @Output() formValidationEvent: EventEmitter<{isValid:boolean, isChanged: boolean}> = new EventEmitter();

    constructor(
    private providerFormBuilder: FormBuilder, 
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) 
  { 
    this.payorkey = parseInt(sessionStorage.getItem("payorkey")?? "0");
  }

  nonEnumeratedProviderFormPart1 = this.providerFormBuilder.group({});
  nonEnumeratedProviderFormPart2= this.providerFormBuilder.group({});
  nonEnumeratedProviderFormPart3 = this.providerFormBuilder.group({});


  ngOnInit(): void {
    this.formdata = this.vendorService.getSessionData();
    this.nonEnumeratedProviderFormData = this.inputDetails == null ? this.formdata.nonEnumeratedProviderDetails : this.inputDetails;
    this.nonEnumeratedProviderFormData1["controls"] = this.nonEnumeratedProviderFormData.controls.slice(0, 8);
    this.nonEnumeratedProviderFormData2["controls"] = this.nonEnumeratedProviderFormData.controls.slice(8, 16);
    this.nonEnumeratedProviderFormData3["controls"] = this.nonEnumeratedProviderFormData.controls.slice(16, 23); 
    let currentUrl = window.location.hash;
    if(currentUrl.includes('additionalInvolvedParties')) {
      const involvedCtrl = this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "additionalInvolvedType");
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }
    else {
      const involvedCtrl = this.formdata.witnessDetails.controls.find((x: { name: string }) => x.name == 'involvedType');
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }

    this.vendorService.getLeadHeaders(this.payorkey, this.vendorService.getStoredInstanceNumber()).subscribe((result)=>{          
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText =  result.Instruction;
      instructionText = instructionText.replace('<img ','<img title="Header" ')
      this.instructionText = instructionText;
    });


    let getStatesApi = this.vendorService.getStateNames();
    let getSubjectRequiredFieldApi = this.vendorService.getSubjectRequiredFieldsByInvolvedParty(this.internalInvolvedPartiesKey, this.payorkey, this.vendorService.getStoredInstanceNumber());
    forkJoin([getSubjectRequiredFieldApi, getStatesApi]).subscribe((response: any) => {
      let result = response[0];
      if(result.EitherOrOptions == 1)
      {
        this.isNameRequired = true;
      }
      this.configureFormFields = result.ConfigureFormFields ?? [];
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepOrgName").validators.required = result.OrganizationName;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepFirstName").validators.required = result.FirstName;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepLastName").validators.required = result.LastName;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepMiddleName").validators.required = result.MiddleName;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepDateOfBirth").validators.required = result.DateofBirth;

      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepSsn").validators.required = result.SSN;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepLicenseNo").validators.required = result.License;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepOtherId").validators.required = result.OtherID;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepOther").validators.required = result.Other;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepPrimaryPhone").validators.required = result.Phone;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepSecondaryPhone").validators.required = result.SecondaryPhone;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepFax").validators.required = result.Fax;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepEmail").validators.required = result.Email;
      
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepStreetAddress1").validators.required = result.AddressLine1;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepCity").validators.required = result.City;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepState").validators.required = result.State;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepCounty").validators.required = result.County;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepZip").validators.required = result.ZipCode;
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepCountry").validators.required = result.Country;

      this.updateAllControlsValidity();
      if(this.isNameRequired)
      {
        let firstnameVal = this.nonEnumeratedProviderFormData1.controls.find((x: any) => x.name === 'nepFirstName').value;
        let lastnameVal = this.nonEnumeratedProviderFormData1.controls.find((x: any) => x.name === 'nepLastName').value;
        let orgnameVal = this.nonEnumeratedProviderFormData1.controls.find((x: any) => x.name === 'nepOrgName').value;
        if ((firstnameVal && firstnameVal !== '') || (lastnameVal && lastnameVal !== '') ||
          (orgnameVal && orgnameVal !== '')) {
            this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepFirstName").validators.required = false;
            this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepLastName").validators.required = false;
            this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepOrgName").validators.required = false;
          }
          else
          {
            this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepFirstName").validators.required = true;
            this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepLastName").validators.required = true;
            this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepOrgName").validators.required = true;
          }

        }
        this.isformloaded = true;
        this.statelist = response[1];
        this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepState").options = response[1].map((x: any) => { return { "value": x.Abbreviation, "key": x.Name } });
        const countyValue = this.nonEnumeratedProviderFormData3.controls.find((x: { name: string; }) => x.name == "nepCounty").value;
        setTimeout(() => {
          if (countyValue) {
            (this.nonEnumeratedProviderFormPart3.get('nepCounty') as any)?.setValue(countyValue);
          }
        }, 1000);
        this.setConfiguredFormFields();
    });

    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);

    this.nonEnumeratedProviderFormPart1.valueChanges.subscribe(() => this.recheckFormValidity());
    this.nonEnumeratedProviderFormPart2.valueChanges.subscribe(() => this.recheckFormValidity());
    this.nonEnumeratedProviderFormPart3.valueChanges.subscribe(() => this.recheckFormValidity());
  }

  updateAllControlsValidity(): void {
    this.nonEnumeratedProviderFormData.controls.forEach((formControl: any) => {
      const control1 = this.nonEnumeratedProviderFormPart1.get(formControl.name);
      const control2 = this.nonEnumeratedProviderFormPart2.get(formControl.name);
      const control3 = this.nonEnumeratedProviderFormPart3.get(formControl.name);
      
      if(control1 != null && formControl.validators.required) {
        control1.setValidators([Validators.required]);
        control1?.updateValueAndValidity({emitEvent: false});
      } else if(control2 != null && formControl.validators.required) {
        control2.setValidators([Validators.required]);
        control2?.updateValueAndValidity({emitEvent: false});
      } else if(control3 != null && formControl.validators.required) {
        control3.setValidators([Validators.required]);
        control3?.updateValueAndValidity({emitEvent: false});
      }
    });
  }
  setConfiguredFormFields() {
    let oldOtherId = this.nonEnumeratedProviderFormData2.controls.find((x: { name: string; }) => x.name == "nepOtherId").label;
    let otherId = this.manualFieldConfig('OnlineIntake', 'InvolvedParty', 'InvolvedPartyType', 'NonEnumProviderOtherId', oldOtherId);
    this.nonEnumeratedProviderFormData2.controls.find((x: { name: string; }) => x.name == "nepOtherId").label = otherId;
  }
    manualFieldConfig(formCategory: string, formName: string, subFormName: string, fieldName: string, defaultValue: string): string | null {
    let result = defaultValue;
    
    if(this.configureFormFields != null && this.configureFormFields.length > 0) {
        this.configureFormFields.forEach((field) => {
            if (
                field.FormCategory &&
                field.FormName &&
                field.SubFormName &&
                field.FieldName &&
                field.FormCategory.toLowerCase() === formCategory.toLowerCase() &&
                field.FormName.toLowerCase() === formName.toLowerCase() &&
                field.SubFormName.toLowerCase() == subFormName.toLowerCase() &&
                field.FieldName.toLowerCase() === fieldName.toLowerCase() &&
                field.FormTypeKey == this.internalInvolvedPartiesKey
            ) {
                result = field.LabelValue ?? defaultValue;
            }
        });
    }

    return result;
  }
  private recheckFormValidity(): void {
    const allValid =
      this.nonEnumeratedProviderFormPart1.valid &&
      this.nonEnumeratedProviderFormPart2.valid &&
      this.nonEnumeratedProviderFormPart3.valid &&
      this.dobValidation();

    if (this.isFormsValid !== allValid) {
      this.isFormsValid = allValid;
      this.cdref.detectChanges();
    }

    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedProviderFormData1.controls.concat(this.nonEnumeratedProviderFormData2.controls, this.nonEnumeratedProviderFormData3.controls);

    this.formdata.nonEnumeratedProviderDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    let isFormChanged = this.nonEnumeratedProviderFormPart1.dirty || this.nonEnumeratedProviderFormPart2.dirty || this.nonEnumeratedProviderFormPart3.dirty;
    this.formValidationEvent.emit({isValid: allValid, isChanged: isFormChanged});
  }

  childInitComplete(){
    this.initCount++;
    this.formValidate(null);
    if (this.initCount === 3) {
      this.setupSubscriptions();
    }
  }

  private setupSubscriptions() {
    if (this.isNameRequired) {
      const firstCtrl = this.nonEnumeratedProviderFormPart1.get('nepFirstName');
      const lastCtrl = this.nonEnumeratedProviderFormPart1.get('nepLastName');
      const orgCtrl = this.nonEnumeratedProviderFormPart1.get('nepOrgName');

      if (firstCtrl && lastCtrl && orgCtrl) {
        this.nameSubscription = merge(
          firstCtrl.valueChanges,
          lastCtrl.valueChanges,
          orgCtrl.valueChanges
        ).subscribe(() => {
          this.updateNameValidators();
        });
      }
    }

    this.formSubscription = merge(
      this.nonEnumeratedProviderFormPart1.valueChanges,
      this.nonEnumeratedProviderFormPart2.valueChanges,
      this.nonEnumeratedProviderFormPart3.valueChanges
    ).subscribe(() => {
      this.formValidate(null);
    });

    if (this.isNameRequired) {
      this.updateNameValidators();
    }
  }

  private loadCounties(abbr: string) {
    this.vendorService.getStateCounties(abbr).subscribe((result) => {
      this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepCounty").options = result.map(x => {return { "value" : x.County, "key" : x.County}});
    });
    this.nonEnumeratedProviderFormData.controls.find((x: { name: string; }) => x.name == "nepCounty").disabled = false;
  }

  private updateNameValidators() {
    if (!this.isNameRequired) return;

    const firstVal = this.nonEnumeratedProviderFormPart1.get('nepFirstName')?.value;
    const lastVal = this.nonEnumeratedProviderFormPart1.get('nepLastName')?.value;
    const orgVal = this.nonEnumeratedProviderFormPart1.get('nepOrgName')?.value;

    const hasAny = !!(firstVal || lastVal || orgVal);

    const firstCtrl = this.nonEnumeratedProviderFormPart1.get('nepFirstName');
    const lastCtrl = this.nonEnumeratedProviderFormPart1.get('nepLastName');
    const orgCtrl = this.nonEnumeratedProviderFormPart1.get('nepOrgName');

    if (hasAny) {
      firstCtrl?.clearValidators();
      lastCtrl?.clearValidators();
      orgCtrl?.clearValidators();

      this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepFirstName").validators.required = false;
      this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepLastName").validators.required = false;
      this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepOrgName").validators.required = false;
    } else {
      firstCtrl?.setValidators([Validators.required]);
      lastCtrl?.setValidators([Validators.required]);
      orgCtrl?.setValidators([Validators.required]);

      this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepFirstName").validators.required = true;
      this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepLastName").validators.required = true;
      this.nonEnumeratedProviderFormData1.controls.find((x: { name: string; }) => x.name == "nepOrgName").validators.required = true;
    }

    firstCtrl?.updateValueAndValidity({ emitEvent: false });
    lastCtrl?.updateValueAndValidity({ emitEvent: false });
    orgCtrl?.updateValueAndValidity({ emitEvent: false });

    this.formValidate(null);
  }

  valueChange(data?: any) {
    if (data && data.name === 'nepDateOfBirth') {
      this.dobValidation();
    }

    if (data?.name === 'nepState') {
      const abbrev = this.statelist.find(y => y.Id == data.value.target.selectedIndex)?.Abbreviation ?? "";
      this.vendorService.getStateCounties(abbrev).subscribe(result => {
        this.nonEnumeratedProviderFormData.controls.find((x: any) => x.name == "nepCounty").options =
          result.map(x => ({ value: x.County, key: x.County }));
      });
      this.nonEnumeratedProviderFormData.controls.find((x: any) => x.name == "nepCounty").disabled = false;
    }
        
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedProviderFormData1.controls.concat(this.nonEnumeratedProviderFormData2.controls, this.nonEnumeratedProviderFormData3.controls);

    this.formdata.nonEnumeratedProviderDetails = tempArr;
    this.vendorService.updateData(this.formdata);
  }

  formValidate(data?: any) {
    if (this.nonEnumeratedProviderFormPart1.valid && this.nonEnumeratedProviderFormPart2.valid && this.nonEnumeratedProviderFormPart3.valid && this.dobValidation()) {
      this.isFormsValid = true;
    } else {
      this.isFormsValid = false;
    }
  }

  private dobValidation(): boolean {
    let result = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dobCfg =
      this.nonEnumeratedProviderFormData1.controls.find((x: any) => x.name === 'nepDateOfBirth') ||
      this.nonEnumeratedProviderFormData2.controls.find((x: any) => x.name === 'nepDateOfBirth') ||
      this.nonEnumeratedProviderFormData3.controls.find((x: any) => x.name === 'nepDateOfBirth');

    const dob = dobCfg && dobCfg.value ? new Date(dobCfg.value) : null;
    let err = '';
    if (dob && dob > today) {
      err = 'Date cannot be in the future.';
      result = false;
    }

    const el = document.getElementById('nepDateOfBirth_Error');
    if (el) el.textContent = err;

    const ctrl = this.nonEnumeratedProviderFormPart1.get('nepDateOfBirth') || this.nonEnumeratedProviderFormPart2.get('nepDateOfBirth') || this.nonEnumeratedProviderFormPart3.get('nepDateOfBirth');
    if (ctrl) {
      if (!result) {
        ctrl.setErrors({ ...(ctrl.errors || {}), futureDate: true });
      } else {
        if (ctrl.errors && ctrl.errors['futureDate']) {
          const { futureDate, ...rest } = ctrl.errors;
          Object.keys(rest).length ? ctrl.setErrors(rest) : ctrl.setErrors(null);
        }
      }
    }
    return result;
  }

  back() {
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.nonEnumeratedProviderFormData1.controls.concat(this.nonEnumeratedProviderFormData2.controls,this.nonEnumeratedProviderFormData3.controls);

    this.formdata.nonEnumeratedProviderDetails = tempArr; 
    this.vendorService.updateData(this.formdata);
    this.router.navigate(['involvedParties']);
  }

  openInstruction() {
    const result  = this.modalService.open(InstructionsComponent, {size: 'lg',  ariaLabelledBy: 'Instructions'});
    result.componentInstance.name = this.instructionText;
  }

  ngOnDestroy() {
    this.nameSubscription?.unsubscribe();
    this.stateSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();
  }
  restoreCountyIfStateExists() {
    const stateConfig = this.nonEnumeratedProviderFormData.controls.find( (c: any) => c.name === 'nepState' );
    const countyConfig = this.nonEnumeratedProviderFormData.controls.find((c: any) => c.name === 'nepCounty' );
    const savedStateAbbr = stateConfig?.value;
    const savedCountyString: string = countyConfig?.value;

    
    if (!savedStateAbbr || !countyConfig) return;

    this.vendorService.getStateCounties(savedStateAbbr).subscribe((result: any[]) => {
      const counties = result.map(x => ({ key: x.County, value: x.County }));

      countyConfig.options = counties;
      countyConfig.disabled = false;

      if (savedCountyString && typeof savedCountyString === 'string') {
        setTimeout(() => {
          const countyControl = this.nonEnumeratedProviderFormPart3.get('nepCounty');
          if (countyControl) {
            (countyControl as any).setValue(savedCountyString);
          }
        }, 0);
      }
    });
  }

}